import { React, useState } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import background1 from '../../assets/header-1.webp'
import background2 from '../../assets/header-2.webp'
import background3 from '../../assets/header-3.webp'
import background4 from '../../assets/header-4.webp'
import background5 from '../../assets/header-5.webp'
import backgroundResp1 from '../../assets/header-1-resp.webp'
import backgroundResp2 from '../../assets/header-2-resp.webp'
import backgroundResp3 from '../../assets/header-3-resp.webp'
import backgroundResp4 from '../../assets/header-4-resp.webp'
import backgroundResp5 from '../../assets/header-5-resp.webp'
import tooltipWhite from '../../assets/tooltip-white.png'
import LayoutCol from '../../components/Layout/LayoutCol'
import WidgetHomeHeader from '../../components/Widget/WidgetHomeHeader'
import { COLOR_BLACK, COLOR_WHITE } from '../../lib/colors'
import UIButton from '../../components/UI/UIButton'
import { IconPlayArrow, IconFleche } from '../../components/Icon/'
import LayoutRow from '../../components/Layout/LayoutRow'
import WidgetMotionDesign from '../../components/Widget/WidgetMotionDesign'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay } from 'swiper'
SwiperCore.use([Autoplay])
import 'swiper/css'
import INT from '../../config/index'
import './style.css'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
  flex: {
    display: 'flex',
    height: '100%',
  },
  customContainer: {
    width: '100vw',
    position: 'relative',
    height: 'auto',
  },
  backgroundImage: {
    objectFit: 'cover',
    width: '100vw',
    height: '100vh',
    '@media (max-width: 480px)': {
      width: '100vw',
    },
  },
  italic: {
    fontStyle: 'italic',
  },
  navbar: {
    position: 'absolute',
    zIndex: 10,
    width: '100vw',
  },
  content: {
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    color: COLOR_WHITE,
    gap: '0.8em',
    '@media (min-width: 480px)': {
      marginTop: '10vh',
    },
    '@media (max-width: 480px)': {
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  title: {
    textAlign: 'center',
    margin: '0px',
    padding: '0px',
    '@media (min-width: 480px)': {
      fontSize: '5vw',
    },
    '@media (max-width: 480px)': {
      fontSize: '10vw',
    },
    lineHeight: '1.1',
  },
  subtitle: {
    letterSpacing: '-0.05em',
    fontSize: '3vw',
    margin: '0px',
    padding: '0px',
    textAlign: 'center',
    maxWidth: '75%',
    '@media (max-width: 480px)': {
      fontSize: '5vw',
      maxWidth: '95%',
    },
  },
  tooltip: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    margin: '35px 0px 25px 0px',
    '@media (min-width: 480px)': {
      cursor: 'pointer',
    },
    '@media (max-width: 480px)': {
      margin: '0px',
      marginTop: '25px',
      position: 'relative',
      borderRadius: '50px',
      backgroundColor: '#08ABAF',
      fontWeight: 700,
      left: '50%',
      height: '57px',
      width: '90vw',
      bottom: '7.5%',
      transform: 'translateX(-50%)',
      gap: '1em',
    },
  },
  tooltipImg: {
    '@media (max-width: 480px)': {
      position: 'absolute',
      width: '20px',
      top: '50%',
      transform: 'translateY(-50%)',
      left: '5%',
    },
  },
  tooltipContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    position: 'absolute',
    zIndex: 5,
    gap: '1em',
  },
  tooltipText: {
    fontWeight: 600,
    fontSize: '18px',
    margin: '0px',
    color: '#08ABAF',
    whiteSpace: 'nowrap',
    '@media (max-width: 480px)': {
      textAlign: 'center',
      fontSize: '15pt',
      color: '#fff',
      fontWeight: 700,
      padding: '10px 0',
    },
  },
  submitMyRequest: {
    borderRadius: '50px',
    backgroundColor: '#08ABAF',
    color: COLOR_WHITE,
    padding: '10px 30px',
    fontWeight: 700,
    letterSpacing: '-0.05em',
    border: '3px solid #FFFFFF',
  },
  buttonMobile: {
    borderRadius: '50px',
    boxShadow:
      '0px 0px 1px rgba(0, 0, 0, 0.25), 0px 3px 8px -1px rgba(50, 50, 71, 0.25)',
    backgroundColor: COLOR_WHITE,
    color: COLOR_BLACK,
    fontWeight: 400,
    letterSpacing: '-0.05em',
    border: '3px solid #FFFFFF',
    margin: '20px auto 10px',
    width: '75vw',
    display: 'flex',
    gap: '.4em',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2.5em',
  },
  smallLayout: {
    '@media (max-width: 480px)': {
      height: '50vh',
      width: '100vw',
    },
    width: '100%',
  },
  text: {
    letterSpacing: '-0.05em',
    fontSize: '18px',
    whiteSpace: 'nowrap',
    '@media (max-width: 480px)': {
      color: '#08ABAF',
    },
  },
  icon: {
    width: '40px',
    margin: '7px',
  },
  icon2: {
    width: '50px',
    margin: '7px',
  },
  swipe: {
    backgroundColor: '#EC503D',
  },
  scrollIcon: {
    position: 'absolute',
    bottom: 10,
    zIndex: 2,
    left: '50%',
    transform: 'translateX(-50%)',
  },
})

const Landscape = () => {
  const { t } = useTranslation('translation')
  const navigate = useNavigate()
  const [isViewerModalOpened, setViewerModalOpened] = useState(false)

  const backgroundListDesktop = [
    background1,
    background2,
    background3,
    background4,
    background5,
  ]
  const backgroundListPhone = [
    backgroundResp1,
    backgroundResp2,
    backgroundResp3,
    backgroundResp4,
    backgroundResp5,
  ]

  const backgroundList = [
    ...(window.innerWidth < 480 ? backgroundListPhone : backgroundListDesktop),
  ]

  return (
    <>
      <WidgetHomeHeader
        smallSize={window.innerWidth < 480}
        dynamicStyle={styles.navbar}
      />
      <LayoutRow className={css(styles.container)}>
        <LayoutCol col={12} dynamicStyle={styles.flex}>
          <Swiper
            pagination={{ clickable: true }}
            className={css(styles.swipe)}
            autoplay={{ delay: 2500 }}
            loop={true}
          >
            {backgroundList.map((img, index) => (
              <SwiperSlide key={index} className={css(styles.swipe)}>
                <img
                  src={img}
                  className={css(styles.backgroundImage)}
                  alt="slipt image phone in hand"
                  width="100%"
                  height="100%"
                />
              </SwiperSlide>
            ))}
          </Swiper>
          {window.innerWidth > 480 && (
            <div className="arrowDown">
              <IconFleche />
            </div>
          )}
        </LayoutCol>
        <div className={css(styles.content)}>
          <h1 className={css(styles.title)}>
            {t('pages.home.landscape.title')}
            <span className={css(styles.italic)}>
              {' '}
              {t('pages.home.landscape.titlePart2')}
            </span>
            {t('pages.home.landscape.exclamationPoint')}
          </h1>
          <h2 className={css(styles.subtitle)}>
            {t('pages.home.landscape.subTitle')}
          </h2>
          {window.innerWidth > 480 && (
            <>
              <span className="hpfonctionnement">
                <div
                  className={css(styles.tooltip)}
                  disabled={!INT.AUTH_PERM}
                  onClick={() => {
                    setViewerModalOpened(true)
                  }}
                >
                  <img
                    src={tooltipWhite}
                    alt="tooltip submit my request"
                    width="auto"
                    height="auto"
                  />
                  <div className={css(styles.tooltipContainer)}>
                    <p className={css(styles.tooltipText)}>
                      {t('pages.home.landscape.howItWorks')}
                    </p>
                    <IconPlayArrow className="iconPlayArrow" />
                  </div>
                </div>
              </span>
              <span className="hplive">
                <UIButton
                  label={t('pages.home.landscape.submitMyRequest')}
                  dynamicStyle={styles.submitMyRequest}
                  textStyle={styles.text}
                  onClick={() => {
                    if (INT.AUTH_PERM === true) {
                      navigate('/create-request')
                    }
                  }}
                />
              </span>
              <WidgetMotionDesign
                isModalOpened={isViewerModalOpened}
                setModalOpened={setViewerModalOpened}
                video={'/assets/viewer.mp4'}
              />
            </>
          )}
        </div>
        {window.innerWidth < 480 && (
          <LayoutCol col={12} xs={6} dynamicStyle={styles.customContainer}>
            <div
              className={css(styles.tooltip)}
              onClick={() => {
                navigate('/create-request')
              }}
            >
              <p className={css(styles.tooltipText)}>
                {t('pages.home.landscape.submitMyRequest')}
              </p>
            </div>
            <div
              className={css(styles.buttonMobile)}
              onClick={() => {
                setViewerModalOpened(true)
              }}
            >
              <>
                <p className={css(styles.text)}>
                  {t('pages.home.landscape.howItWorks')}
                </p>
                <IconPlayArrow className="iconPlayArrow" />
              </>
            </div>
            <WidgetMotionDesign
              isModalOpened={isViewerModalOpened}
              setModalOpened={setViewerModalOpened}
              video={'/assets/viewer.mp4'}
            />
          </LayoutCol>
        )}
      </LayoutRow>
    </>
  )
}

export default Landscape
